export default "__VITE_ASSET__1f343b44__"